import { render, staticRenderFns } from "./Teaching.vue?vue&type=template&id=1b3a085a&scoped=true&"
import script from "./Teaching.vue?vue&type=script&lang=js&"
export * from "./Teaching.vue?vue&type=script&lang=js&"
import style0 from "./Teaching.vue?vue&type=style&index=0&id=1b3a085a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a085a",
  null
  
)

export default component.exports